import { motion } from "framer-motion";
import { Wordmark } from "@/components/Logo";

// The moment Xcelio opens: the Orb X gently breathes and its gold X shimmers.
export default function BrandSplash() {
  return (
    <motion.div
      data-testid="brand-splash"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center overflow-hidden"
      style={{ background: "radial-gradient(120% 90% at 50% 32%, #10182e 0%, #0a0f1e 55%, #060912 100%)" }}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* breathing orb */}
      <motion.div
        className="relative flex items-center justify-center"
        animate={{ scale: [1, 1.055, 1] }}
        transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
      >
        {/* soft outer aura */}
        <motion.div
          className="absolute rounded-full"
          style={{ width: 220, height: 220, background: "radial-gradient(circle, rgba(120,150,190,0.20), transparent 68%)", filter: "blur(10px)" }}
          animate={{ opacity: [0.5, 0.85, 0.5] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <svg width="150" height="150" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Xcelio">
          <defs>
            <radialGradient id="splashOrb" cx="42%" cy="38%" r="72%">
              <stop offset="0%" stopColor="#d3dcea" />
              <stop offset="24%" stopColor="#93a6be" />
              <stop offset="50%" stopColor="#566579" />
              <stop offset="78%" stopColor="#2d3543" />
              <stop offset="100%" stopColor="#141922" />
            </radialGradient>
            <linearGradient id="splashGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#c99a4f" />
              <stop offset="0.5" stopColor="#f7e6bd" />
              <stop offset="1" stopColor="#c99a4f" />
              {/* animated shimmer sweep across the X */}
              <animateTransform attributeName="gradientTransform" type="translate"
                values="-1 0; 1 0; -1 0" dur="2.6s" repeatCount="indefinite" />
            </linearGradient>
            <filter id="splashSoft" x="-40%" y="-40%" width="180%" height="180%">
              <feGaussianBlur stdDeviation="2.2" />
            </filter>
          </defs>
          <circle cx="60" cy="60" r="55" fill="url(#splashOrb)" />
          {/* smoke wisps */}
          <g style={{ mixBlendMode: "screen" }} filter="url(#splashSoft)">
            <ellipse cx="46" cy="48" rx="20" ry="14" fill="#c4d2e6" opacity="0.16" />
            <ellipse cx="74" cy="72" rx="18" ry="13" fill="#1c2330" opacity="0.30" />
          </g>
          <ellipse cx="43" cy="37" rx="13" ry="9" fill="#eef3fb" opacity="0.35" filter="url(#splashSoft)" />
          {/* gold X with shimmer */}
          <g strokeLinecap="round">
            <g stroke="#8a6a1f" strokeWidth="14" opacity="0.35">
              <line x1="42" y1="42" x2="78" y2="78" />
              <line x1="78" y1="42" x2="42" y2="78" />
            </g>
            <g stroke="url(#splashGold)" strokeWidth="12">
              <line x1="42" y1="42" x2="78" y2="78" />
              <line x1="78" y1="42" x2="42" y2="78" />
            </g>
          </g>
        </svg>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.9, ease: "easeOut" }}
        className="mt-8"
      >
        <Wordmark className="text-3xl text-white" />
      </motion.div>
    </motion.div>
  );
}
